<template>
    <div id="DiscountCustomerList">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <!-- <div class="bg-white data-table p-0" v-if="customerVal != undefined">
            <data-table-filter-config :moduleName="'DiscountCustomerList'" ref="filterComponent" @cancelSelection="cancelAll"></data-table-filter-config>
            <custom-pagination
                :page-changed="onPageChange"
                :per-page-changed="onPerPageChange" :moduleName="'DiscountCustomerList'">
            </custom-pagination>

            <vue-good-table
                ref="listDiscountCustomerTable"
                mode="remote"
                title="Customer"
                @on-page-change="onPageChange"
                @on-selected-rows-change="selectionChanged"
                @on-column-filter="onColumnFilter"
                @on-per-page-change="onPerPageChange"
                @on-sort-change="onSortChange"
                @on-select-all="onSelectAll"
                :totalRows="totalRecords"
                :columns="columns"
                :rows="rows"
                :pagination-options="{
                    enabled: false,
                    position: 'both',
                    perPage: perPage,
                    setCurrentPage:listCurrentPage,
                    perPageDropdown:dropDownPerPage,
                    dropdownAllowAll: false,
                }"
                :select-options="{
                enabled: canDeleteCustomer,
                selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                selectionInfoClass: 'custom-class',
                selectionText: 'rows selected',
                clearSelectionText: 'clear',
                }"
                :search-options="{
                enabled: false,
                }">

                <div slot="selected-row-actions">
                    <button v-if="canDeleteCustomer" id="deleteCustomerBtn" v-on:click.prevent="customerDelete" class="btn btn-danger">Delete</button>
                </div>
            </vue-good-table>
            <custom-pagination
                :page-changed="onPageChange"
                :per-page-changed="onPerPageChange" :moduleName="'CustomerList'">
            </custom-pagination>
        </div> -->
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title">Customer Discount View</div>
                        <div class="web-action-btn btn-groups text-right">

                            <!-- <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data> -->
                            <div class="btn-groups pull-right">
                                <router-link title="Back" v-if="redirectFrom == 'bank'" class="btn btn-secondary" v-bind:to="{name: 'BankTransferList'}"><i class="fp-back"> </i>Back </router-link>
                                <router-link title="Back" v-else class="btn btn-secondary" v-bind:to="{name: 'CustomerDiscountList'}"><i class="fp-back"> </i>Back </router-link>
                            </div>
                        </div>
                    </div>
                <div class="container-fluid">
                    <div class="admin-page-content program-asset-list list-view">
                      <section class="internal-container">
                        <div id="tabs" class="containerTab mt-3">
                          <div class="tabs">
                            <a v-on:click="activetab=1" v-bind:class="[ activetab === 1 ? 'active' : '' ]">Fuel Drop Details</a>
                            <a v-on:click="activityLogs()" v-bind:class="[ activetab === 2 ? 'active' : '' ]">Activity Log</a>
                          </div>
                          <div class="content">
                            <div v-show="activetab === 1" class="tabcontent">
                            <div class="list-sections">
                        <div class="form-row no-divider">
                                <div class="col-md-3">
                                    <div class="row form-group">
                                        <label class="col">Name:</label>
                                        <span class="col"> {{ name }} </span>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="row form-group">
                                        <label class="col">Type:</label>
                                        <span class="col"> {{ type }} </span>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="row form-group">
                                        <label class="col">Discount:</label>
                                        <span class="col"> {{ discount }} </span>
                                    </div>
                                </div>
                            </div>
                            </div>

                        </div>
                        <div v-show="activetab === 2" class="tabcontent" id="customer-activity-logs" >
                            <discount-activity-log-list :activityLogVal="activityLogsTabValue"></discount-activity-log-list>
                        </div>
                        </div>
                        </div>
                        <div id="discount-detail work-order-view-top" class="tabcontent" v-if="activetab === 1">
                        <data-table-filter-config :moduleName="'DiscountCustomerList'" ref="filterComponent" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <section class="bg-white data-table">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'DiscountCustomerList'" :position="'top'">
                                </custom-pagination>
                                <vue-good-table
                                    ref="listDiscountCustomerTable"
                                    mode="remote"
                                    title="Discount Customer List"
                                    @on-page-change="onPageChange"
                                    @on-selected-rows-change="selectionChanged"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    :totalRows="totalRecords"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"

                                    :search-options="{
                                    enabled: false,
                                    }">

                                    <!-- <div slot="selected-row-actions">
                                        <button v-if="canDeleteCustomer" id="deleteCustomerBtn" v-on:click.prevent="customerDelete" class="btn btn-danger">Delete</button>
                                    </div> -->
                                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">
                                            <div v-if="props.column.field == 'action'" class='align-center'>
                                                <!-- <template>
                                                    <router-link title="Update Card Rate" class="fp-edit mr-3" v-bind:to="{name: 'CardRateConfiguration',params:{id:props.row.id},query:{'from':'customer'}}"></router-link>
                                                </template> -->
                                            </div>
                                            <div v-else>
                                                {{props.formattedRow[props.column.field]}}
                                            </div>
                                        </div>
                                    </template>


                                </vue-good-table>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                        </section>
                        </div>
                      </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="col-md-12">
                    <div class="error-template">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

import EventBus from "./event-bus";
import Vue from "vue";
import ActivityLogListView from '@/components/ActivityLogList.vue';
Vue.component("discount-activity-log-list", ActivityLogListView);
import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';

import { locale } from 'moment';

    export default {
        name: "DiscountCustomerList",
        mixins:[commonMixins,dataTableMixins],
        props: {
            customerVal: {
                type: String,
                required: false,
                default:undefined
            },
        },
        data: () => ({
            firstLoad: 0,
            permissions: [],
            userColumns:[],
            cantAccessPage: "",
            columns: [
                //  {
                //     label: 'Actions',
                //     field: 'action',
                //     hidden:false,
                //     sortable: false,
                // },
                {
                    label: 'Code',
                    field: 'code',
                    filterable: true,
                    fpFieldType:"text",
                    width:'140px',
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Code", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterFn: this.onColumnFilter,
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Name',
                    field: 'name',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Name", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Email',
                    field: 'email',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Email", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Phone',
                    field: 'work_phone',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Phone", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'City',
                    field: 'city',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "City", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'State',
                    field: 'state',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "State", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Stage',
                    field: 'stage',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "All", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: ['Potential', 'Account Pending', 'Credit Denied', 'New', 'Existing'],
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Created At',
                    field: 'created_at',
                    fpFieldType:"date",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Status',
                    field: 'status',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "All", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: ['Unverified','Active', 'Inactive'],
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Outstanding AR',
                    field: 'outstanding_ar',
                    fpFieldType:"integer",
                    filterable: true,
                    hidden:false,
                    type:'number',
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Outstanding AR", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                // {
                //     label: 'Actions',
                //     field: 'action',
                //     hidden:false,
                //     sortable: false,
                // },
            ],
            rows: [],
            totalRecords: 0,
            loading:false,
            customerStage:"",
            custId:0,
            action:"list",
            action_name:"remove customer",
            checkListActionsArray:[],
            checkListActionData:{
                parent_action:'',
                module_checklist:[],
                reference:'customer',
                reference_id:[]
            },
            pageKey:"_customer_list_",
            name:'',
            type:'',
            discount:'',
            redirectFrom:'list',
            activetab: 1,
            activityLogsTabValue: "dontLoadList",
            activityLoaded:false,
        }),
        metaInfo () {
            return {
                title: 'Discount Customer List | FleetPro Application'
            }
        },
        watch:{

            //check permission change
            permissions: function (permissions) {

                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'view_customer_discount') {
                            self.cantAccessPage = true;
                        }
                    }
                }

            }

        },
        created: function() {
            this.serverParams.sort = {field:"updated_at",type:"desc"};
        },
        mounted: function() {
            var self = this;

            self.getPermissions();
            self.loadCustomerDiscount();

            var webloc = window.location.href;

            var decodeStr = "";

            if ( this.$route.query.data != '' && this.$route.query.data != undefined ) {

                decodeStr = atob(this.$route.query.data)

            }

            var url = new URL(webloc+"?"+decodeStr);
            var from = url.searchParams.get("redirectFrom");
            if (from != undefined){
                self.redirectFrom = from;
            }
            // if( self.customerVal != undefined){

            //     for( var i=0; i<this.columns.length; i++ ) {
            //         if ( this.columns[i].field == 'action' ) {
            //             this.$set(this.columns[i], 'hidden', true)
            //         }
            //     }

            // }
            //self.loadList();
        },
        methods: {
             cancelAll: function (cancelAll) {
              this.$refs.listDiscountCustomerTable.unselectAllInternal();
            },
            titleCase(str) {
                if (str == null){
                    return;
                } else{
                    var value = str.toString()
                    return value.charAt(0).toUpperCase() + value.slice(1)
                }
            },

            //for populate customer's current stage in dropdown and to change stage of customer
            selectionChanged(param) {

                var self = this;
                self.serverParams.selectedAll = false;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                return;

                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['listDiscountCustomerTable'].selectedRows;
                // var use = [];
                // for (var i = 0; i < rowData.length; i++) {
                //     use.push(this.$refs['listDiscountCustomerTable'].selectedRows[i].id)
                // }
            },
            customerDelete:function(){
                var self = this;
                self.action = 'delete';
                self.loadList();
            },
            loadCustomerDiscount() {
                var path = window.location.pathname;
                var segments = path.split("/");
                var self = this;
                self.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/customer-discount/" + segments[3],
                    type: "GET",
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if (data.status == "success") {

                            self.name = data.content.name;
                            self.discount = data.content.discount;
                            self.type = self.titleCase(data.content.type);
                            // self.selectedArray = data.content.customers;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'load-contract-data')
                    }
                });
            },

            loadList() {

                var self = this;

                self.loading = true;
                //get selected customers ids

                var selectedRows = [];

                if ( self.firstLoad == 1 ) {
                    //because on first load list not initialize
                    var data = this.$refs['listDiscountCustomerTable'].selectedRows;
                    for ( var i = 0; i < data.length; i++ ) {
                        selectedRows.push(this.$refs['listDiscountCustomerTable'].selectedRows[i].id)
                    }
                }

                var fields = {

                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                    flag: self.flag,
                    selectedRows:selectedRows,
                    action:self.action,
                    selectedAll:self.serverParams.selectedAll,
                    id:self.$route.params.id

                };

                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/discount-customer/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // console.log(data);
                        if (data.status == "success") {

                            if ( self.action == "delete" ) {

                                self.action = "list";
                                $("#deleteCustomerBtn").val("Delete");

                                self.$refs.filterComponent.clearSelectAll();
                                self.loadList();

                            }else{

                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                                self.filteredFlag = false;

                            }

                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if ( self.action == "delete" ) {
                            self.generateStatusCodeMessage(jqXHR,true,'scope-customer-delete-error')
                        }else{
                            self.generateStatusCodeMessage(jqXHR,false,'scope-customer-list-error')
                        }

                    }
                });
            },
            activityLogs(){

              var self = this;
              var path = window.location.pathname;
              var segments = path.split("/");

              self.$root.$emit('activity_log_opted','customer discount',segments[3]);
              self.activityLogsTabValue = "loadList";     // flag value set to loadList so that filters in list work properly.
              self.activetab = 2;
            },
        }
    };
</script>





// WEBPACK FOOTER //
// src/components/DiscountCustomerList.vue